const submitForm = {
  initSubmit: () => {
    const contactForm = document.querySelectorAll('form.wpcf7-form');
    //submit button
    const submitButton = document.querySelector('.submit_button .wpcf7-form-control.wpcf7-submit');
    //validation message
    const errorMessage = document.querySelector('.wpcf7-response-output');

    document.addEventListener(
      'wpcf7submit',
      function () {
        if (contactForm[0].classList.contains('sent')) {
          setTimeout(function () {
            submitButton.value = 'Submitted';
            submitButton.textContent = `Submitted!`;

            document.querySelector('.submit_button').classList.add('check');
          }, 800);
        } else {
          errorMessage.style.display = 'inline-block';
          setTimeout(function () {
            errorMessage.style.display = 'none';
          }, 4000);
        }
      },
      false
    );
  },
};

export default submitForm;
